import type { FilterMultiSelection } from "@filter/filter.types";
import { DynamicFilter } from "./dynamic-filter";
import { SimpleFilterMulti } from "./simple-filter-multi";

export abstract class DynamicFilterMulti<TItem> extends DynamicFilter<FilterMultiSelection, TItem> {
    protected filtersCached: Map<string, SimpleFilterMulti<TItem>> = new Map();
}
